import { makeStyles, tokens } from '@fluentui/react-components';

export const useComboBoxStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS,
    // Allow the field (and the Combobox inside) to shrink below its content's
    // intrinsic width when laid out in a narrow grid cell — otherwise Fluent's
    // default `min-inline-size: 250px` causes the input to overflow its column
    // and visually collide with neighbouring fields at smaller desktop widths.
    minWidth: 0,
    '& .fui-Combobox': {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& .fui-Combobox__input': {
      minWidth: 0,
    },
  },
  listbox: {
    maxHeight: '18.75rem !important' as unknown as string,
  },
});
